import { HttpService } from './base.service'

class PlanService extends HttpService {
  private readonly prefix = 'plans'
  getPlans = () => this.get(`${this.prefix}/get-plans`)
}

export const planService = new PlanService()
